import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.724 1.276 1.367 25.633a9.23 9.23 0 0 1-.5-1.509c-.698-2.79-.897-5.615-.864-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263l.034.013ZM6.262 30.738 30.646 6.354c.385.907.52 1.555.52 1.555.665 2.757.864 5.582.83 8.107.034 2.493-.199 5.317-.863 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23a6.764 6.764 0 0 1-.08-.032Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M24.193.807.868 24.132l-.002-.008c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c2.984.026 6.01.284 8.193.807Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M7.797 31.203 31.153 7.847l.014.062c.663 2.758.862 5.582.83 8.107.032 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-2.997-.027-6.036-.287-8.203-.797Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M1.872 5.317c.063-.114.129-.23.198-.347l1.568-.193-.53-1.248c.127-.145.26-.289.4-.43l1.27.539.212-1.73c.08-.05.16-.099.244-.146l1.1 1.459 1.294-1.717.262 2.134 1.98-.84-.841 1.98 2.134.261-1.717 1.294 1.717 1.294-2.134.263.84 1.979-1.98-.84-.261 2.134-1.294-1.717-1.295 1.717-.262-2.134-1.979.84.84-1.98-2.134-.262L3.22 6.333 1.872 5.317Zm4.462 4.016a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M6.333 8.667a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagNam = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagNam_default = SvgFlagNam;

export { FlagNam_default as default };
